export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-19-53986ee4bd85f6a704a5a9224ca8f1b8.png";